import React, { useState, useEffect } from 'react';
//import { useForm } from "react-hook-form";
import DateRangeSelector from "../DateRangeSelector.js";
import RoomsGuestsSelector from "../RoomsGuestsSelector.js";
import { format } from 'date-fns';
import ReactModal from 'react-modal';

export default function SearchBar(props) {

    //const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checkIn, setCheckIn] = useState(props.reservation.checkIn);  //string
    const [checkOut, setCheckOut] = useState(props.reservation.checkOut); //string
    const [nights, setNights] = useState(props.reservation.nights);
    //const [adults, setAdults] = useState(props.adults);
    //const [children, setChildren] = useState(props.children);
    //const [promoCode, setPromoCode] = useState(props.reservation.promoCode == '' ? 'LOVETOWER' : props.reservation.promoCode);
    const [promoCode, setPromoCode] = useState('LOVETOWER');
    const [rooms, setRooms] = useState(props.reservation.selectedRooms);
    const [invalidPromo, setInvalidPromo] = useState(false);
    const [checkInDate, setCheckInDate] = useState(new Date(props.reservation.checkIn));  //Date
    const [checkOutDate, setCheckOutDate] = useState(new Date(props.reservation.checkOut)); //Date
    const today = new Date();
    
    const [showModal, setShowModal] = useState(props.showDatePicker);
    const [showModalR, setShowModalR] = useState(false); //guests per room
    const modalStyle = () => ({
        overlay: {
            display: 'inline-block',
            position: 'fixed',
            overflow: 'hidden',
            //height: '100%'
            //top: 0,
            //left: 0,
            //right: 0,
            //bottom: 0,
            //backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
            display: 'block',
            verticalAlign: 'middle',
            //position: window.innerwidth > 600 ? 'relative' : 'fixed',
            top: window.innerWidth > 600 ? '128px' : '10px',
            bottom: window.innerWidth > 600 ? 'initial' : '10px',
            //left: window.innerWidth > 600 ? 'none' : '0px',
            //right: window.innerWidth > 600 ? 'none' : '0px',
            width: window.innerWidth > 600?'600px':'320px',
            //height: '400px',
            //border: '1px solid #ccc',
            background: '#fff',
            overflow: isTouchDevice() ? 'auto' : 'auto',
            WebkitOverflowScrolling: 'touch',
            //borderRadius: '4px',
            outline: 'none',
            padding: '6px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    })

    

    const modalStyleR = () => ({
        overlay: {
            display: 'inline-block',
            position: 'fixed',
          
        },
        content: {
            display: 'block',
            //verticalAlign: 'middle',
            //position: 'relative',
            top: window.innerWidth > 600 ? '128px' : '10px',
            bottom: window.innerWidth > 600 ? 'initial' : '10px',
            //left: '60px',
            width: window.innerWidth > 600?'340px':'340px',
            //border: '1px solid #ccc',
            background: '#fff',
            overflowX: 'hidden',
            overflowY: 'auto',
            maxHeight: window.innerWidth > 600 ? window.innerHeight - 138 : window.innerHeight - 20,
            WebkitOverflowScrolling: 'touch',
            //borderRadius: '4px',
            outline: 'none',
            padding: '6px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    })

    function isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    function submit (startDate, endDate, n, r, p) {
        props.search(startDate, endDate, n, r, p);
    };

    function regEx(promotions) {
        return new RegExp('(' + promotions.map((promo) => {
            return ('|\\b' + promo.name + '\\b');
        }).toString().substring(1).replace(',', '') + ')')
    };

    function applyDates(startDate, endDate, n) {
        setCheckIn(startDate.toDateString());
        setCheckOut(endDate.toDateString());
        setCheckInDate(startDate);
        setCheckOutDate(endDate);
        setNights(n);
        isPromoValid(startDate, endDate, promoCode);
        submit(startDate, endDate, n, rooms, promoCode);
        closeDateRangeSelector();
        
    }

    function isPromoValid(checkInDate, checkOutDate, promoCode) {

        if (promoCode === "") {
            setInvalidPromo(false);
            return;
        }

        let finalNight = new Date(checkOutDate);
        finalNight.setDate(finalNight.getDate() - 1); 

        let valid = false;
        let p = props.promotions.find(p => p.name === promoCode);
        if (p) {
            valid = true;
            if (p.dateFrom < checkInDate && p.dateTo < checkInDate || p.dateFrom > finalNight && p.dateTo > finalNight) valid = false;
        }

        setInvalidPromo(!valid);
        return;
    }

    function applyRooms(r) {
        setRooms(r);
        submit(checkInDate, checkOutDate, nights, r, promoCode);
        closeRoomsGuestsSelector();
    }

    function applyPromo(e) {
        
        let text = e.target.value;

        
        if (text === "") {
            
            if (!invalidPromo) {
                //setPromoCode(text);
                submit(checkInDate, checkOutDate, nights, rooms, text);
            }
            
            return;
        }

        let promo = props.promotions.some(p => p.name === text && p.dateFrom <= checkInDate && p.dateTo >= checkOutDate);
        if (promo) {
            setInvalidPromo(false);
            setPromoCode(text);
            submit(checkInDate, checkOutDate, nights, rooms, text);
            
        }
        else {
            if (!invalidPromo) {
                setInvalidPromo(true);
                setPromoCode(text);
                submit(checkInDate, checkOutDate, nights, rooms, text);
            }
            else {
                setPromoCode(text);
            }
            
        }
        
    }

    function openDatePicker() {
        if (props.reservation.selectedRooms.length === 1 && props.reservation.selectedRooms[0].roomType === undefined) {
            setShowModal(true);
        }
        else {
            if (window.confirm('If you change your arrival or departure date you will need to re-select your rooms based on availabilty on your new dates.')) changeDates();
        } 
    }

    
    function closeDateRangeSelector() {
        setShowModal(false);
    }

    function closeRoomsGuestsSelector() {
        setShowModalR(false);
    }

    const changeDates = () => {
        //warn will reset rooms
        
        props.changeDates();
        setShowModal(true);
    }
    
    return (
        /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
        <div>
            <div>Select your dates</div>
            <div class="row">
                <div class="col-sm-5" style={{padding: '2px'}}>
                    <button type='button' class='btn btn-light' style={{ width: '100%' }} onClick={() => openDatePicker()} >
                        <div class="row">
                            <div class="col border-right">
                                <span class='small'>Check-in</span><br />
                                <span class=''>{checkInDate.getFullYear() === today.getFullYear() ? format(checkInDate, 'eee dd MMM') : format(checkInDate, 'eee dd MMM yyyy')}</span>
                            </div>
                            <div class="col">
                                <span class='small'>Check-out</span><br />
                                <span class=''>{checkOutDate.getFullYear() === today.getFullYear() ? format(checkOutDate, 'eee dd MMM') : format(checkOutDate, 'eee dd MMM yyyy')}</span>
                            </div>
                        </div>
                    </button>
                    <ReactModal
                        isOpen={showModal}
                        contentLabel="Minimal Modal Example"
                        style={modalStyle()}
                    >

                        <DateRangeSelector

                            startDate={new Date(new Date(checkIn).toDateString())}
                            endDate={new Date(new Date(checkOut).toDateString())}
                            apply={(startDate, endDate, n) => applyDates(startDate, endDate, n)}
                            close={() => closeDateRangeSelector()}
                            closedDates={props.closedDates}
                        />

                    </ReactModal>
                    
                </div>
                <div class="col-sm-4" style={{ padding: '2px' }}>
                    <button type='button' class='btn btn-light' style={{ width: '100%' }} onClick={() => setShowModalR(true)} >
                        <div className="row">
                            <div class="col-sm">
                                <span class="small">Guests</span><br/>
                                <span>{rooms.length.toString() + ' rooms, ' +
                                (rooms.reduce((accum, item) => accum + item.adults, 0) +
                                        rooms.reduce((accum, item) => accum + item.children, 0)) + ' guests'}</span>
                            </div>
                        </div>
                    </button>
                    <ReactModal
                        isOpen={showModalR}
                        contentLabel="Minimal Modal Example"
                        style={modalStyleR()}
                    >

                        <RoomsGuestsSelector
                            roomTypes={props.roomTypes}
                            selectedRooms={props.reservation.selectedRooms}
                            //rooms={props.reservation.selectedRooms}
                            apply={(r) => applyRooms(r)}
                            close={() => closeRoomsGuestsSelector()}
                            mode={props.mode}
                            //changeAdults={props.changeAdults}
                            //changeChildren={props.changeChildren}
                        />

                    </ReactModal>
                </div>
                <div class="col-sm-3">
                    <div><span class="small">Enter Promo Code:</span></div>
                    <div><input type='text' name="promo" defaultValue={promoCode} onChange={(e) => applyPromo(e)} autoComplete="off"
                        style={{height: '38px'}}                    /></div>
                    {invalidPromo &&
                    <div><span class="small text-danger">Code not valid or expired</span></div>}
                </div>
                
            </div>

            

            
            
        </div>
    );
}